/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Home\HomeTitle\HomeTitle.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday September 3rd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 3rd 2024 3:26:46 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import { useEffect, useState } from "react";
import Styles from "Content/Home/HomeTitle/HomeTitle.module.css";
import { TextFilter } from "Content/Filters/TextFilter/TextFilterHolder/TextFilterHolder";
import { NavLink, useLocation } from "react-router-dom";
import { GetFilters } from "Utils/UrlParams";
import RouterPathResolver from "Config/Router/RouterPathResolver";

export default function HomeTitle() {
    const location = useLocation();
    const [myFilters, setMyFilters] = useState(GetFilters(location.search));
    const [play, setPlay] = useState(false);

    const handleFilterChange = async (filters: string[]) => {
        setMyFilters(filters);
    };

    const urlToNavigate = (filters: string[])=>{
        return `${RouterPathResolver.routeCars.path}?page=1&filters=${filters}`;
    };

    useEffect(() => {
        setPlay(true);
    }, []);

    return (
        <div className={`${Styles.holder}`}>
            <div className={`${Styles.homeText}`}>
                <h1 className={`${Styles.homeTitle}`}> {translator.decode("home.title")}</h1>
                <div className={`${Styles.filters}`}>
                    <TextFilter id="Filters" themeColor={""} curFilters={myFilters} filtersSelected={handleFilterChange}/>
                    <NavLink className={`${Styles.btnGoTo}`} to={urlToNavigate(myFilters)}> {translator.decode("home.showStock")} </NavLink>
                </div>
            </div>
            <video className={`${Styles.picture}`} preload="auto" muted autoPlay={play} loop playsInline poster="bg.png"><source src="/bg.mp4" type="video/mp4" /></video>
            {/* <img className={`${Styles.picture}`} src="bg-holidays.png" alt="Holidays" /> */}
        </div>
    );
};
